import { Container, Store } from 'AppReact';
import { ButtonWrapper, TitleWrapper, Wrapper } from '../../../common/wrappers';
import { CloseButton, Title } from '../../../common/atoms';
import { ModalCloseButton } from 'components/icons';

const ModalHeader = Container({
  name: 'ModalHeader',
  props: { termsModal: Store },
  elements: [
    {
      name: 'Header',
      wrapper: Wrapper,
      elements: [
        {
          name: 'TitleElement',
          wrapper: TitleWrapper,
          elements: [
            {
              component: Title,
              name: 'Title',
              bindings: () => ({}),
              displayValue: () => 'Please Accept the Terms and Conditions',
            },
          ]
        },
        {
          wrapper: ButtonWrapper,
          isButton: true,
          name: 'CloseButton',
          bindings: ({ termsModal }) => ({ termsModal }),
          elements: [
            {
              component: CloseButton,
              name: 'Button',
              bindings: () => ({}),
              displayValue: () => ModalCloseButton({})
            }
          ]
        }
      ]
    }
  ]
})

export default ModalHeader;
